import { useCallback } from 'react';
import { addMinutes } from '../../../utils/dateUtils';
import useUserChatInfoLazy from '../../hooks/user/useUserChatInfo';

const cacheEntryTtlMins = 10;
const userInfoCache: any = {};

const useUserInfoLocal = () => {
  const { execute } = useUserChatInfoLazy();

  const getUserInfo = useCallback(
    async (
      username: string,
      refresh?: boolean
    ): Promise<{
      avatarUrl: string;
      name: string;
    }> => {
      if (!username) {
        return Promise.resolve({
          avatarUrl: '',
          name: '',
        });
      }
      if (
        userInfoCache[username] &&
        (userInfoCache[username].expiryDate === undefined ||
          userInfoCache[username].expiryDate > new Date()) &&
        !refresh
      ) {
        return Promise.resolve(userInfoCache[username].data);
      } else {
        const result = await execute({
          username,
        });
        userInfoCache[username] = {
          expiryDate: addMinutes(new Date(), cacheEntryTtlMins),
          data: {
            avatarUrl: result.avatarUrl,
            name: result.name,
          },
        };
        return userInfoCache[username].data;
      }
    },
    [execute]
  );
  return {
    getUserInfo,
  };
};

export default useUserInfoLocal;
